import React from 'react';
import { Box, Container, Typography, Grid, Card, CardContent, CardMedia, Button, Chip } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';

// Services and Store
import { firebaseWinesService } from '../services/firebaseService';
import { formatPrice } from '../utils/format';
import { useCartStore } from '../store/useStore';

const WineShop = () => {
  const navigate = useNavigate();
  const { addItem } = useCartStore();

  // Fetch wines
  const { data: winesData, isLoading } = useQuery(
    ['wines'],
    async () => {
      const response = await firebaseWinesService.getAll();
      // El servicio de Firebase retorna { data: { data: [...] } }
      return { wines: response.data.data };
    }
  );

  const handleAddToCart = (wine) => {
    addItem(wine, 1);
  };

  if (isLoading) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Typography variant="h6" textAlign="center">
          Cargando vinos...
        </Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography
        variant="h2"
        sx={{
          textAlign: 'center',
          mb: 4,
          fontFamily: '"Playfair Display", serif',
          fontSize: { xs: '2rem', md: '2.5rem' }
        }}
      >
        Nuestra Tienda de Vinos
      </Typography>

      <Grid container spacing={3}>
        {winesData?.wines?.map((wine) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={wine._id}>
            <Card
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                cursor: 'pointer',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  transition: 'transform 0.2s ease'
                }
              }}
              onClick={() => navigate(`/vino/${wine._id}`)}
            >
              <CardMedia
                component="img"
                height="200"
                image={wine.imageUrl || wine.image || ''}
                alt={wine.name}
                sx={{
                  objectFit: 'contain',
                  bgcolor: 'grey.100'
                }}
              />
              <CardContent sx={{ flexGrow: 1 }}>
                <Box sx={{ mb: 1 }}>
                  <Chip
                    label={wine.denomination}
                    size="small"
                    color="primary"
                    variant="outlined"
                  />
                </Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    mb: 1,
                    fontSize: '1rem',
                    lineHeight: 1.3,
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden'
                  }}
                >
                  {wine.name}
                </Typography>
                {wine.rating > 0 && (
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <Box sx={{ 
                      bgcolor: 'secondary.main', 
                      color: 'white', 
                      px: 1, 
                      py: 0.5, 
                      borderRadius: 1,
                      fontSize: '0.8rem',
                      fontWeight: 600
                    }}>
                      {wine.rating}
                    </Box>
                    <Typography variant="caption" sx={{ ml: 1, color: 'text.secondary' }}>
                      {wine.ratingSource}
                    </Typography>
                  </Box>
                )}
                <Typography
                  variant="h6"
                  color="primary"
                  sx={{ fontWeight: 700, fontSize: '1.2rem', mb: 2 }}
                >
                  {formatPrice(wine.price)}
                </Typography>
                <Button
                  fullWidth
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleAddToCart(wine);
                  }}
                  sx={{
                    bgcolor: 'secondary.main',
                    '&:hover': {
                      bgcolor: 'secondary.dark'
                    }
                  }}
                >
                  Añadir al Carrito
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {(!winesData?.wines || winesData.wines.length === 0) && (
        <Box sx={{ textAlign: 'center', py: 8 }}>
          <Typography variant="h6" color="text.secondary">
            No se encontraron vinos
          </Typography>
        </Box>
      )}
    </Container>
  );
};

export default WineShop; 